import { EntityTypes } from './enums/entityTypes';
import { QuestionTypes } from './enums/questionTypes';

export interface SupplierRequestAssessment {
  assessmentId: string;
  entityType: EntityTypes.assessment;
  questions: SupplierRequestAssessmentQuestion[];
  created: number;
}

export interface SupplierRequestAssessmentQuestion {
  id: string;
  section?: string;
  question: string;
  type: QuestionTypes.yesNo | QuestionTypes.multipleChoice | QuestionTypes.fill;
  choices?: string[];
  documentation: boolean;
  documentation_desc?: string;
}
